import { render, staticRenderFns } from "./PanelContainer.vue?vue&type=template&id=21dc21ca&"
import script from "./PanelContainer.vue?vue&type=script&lang=ts&"
export * from "./PanelContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports